import React from 'react';
import { colors, typography } from '../../../styles/theme';
import { FILTER_ACCENT, FILTER_ACCENT_20 } from './FilterPanel.styles';

const chipsWrapStyle = (columns) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
  gap: '6px',
  width: '100%',
});

const chipStyle = ({ active = false, disabled = false } = {}) => ({
  width: '100%',
  minWidth: 0,
  boxSizing: 'border-box',
  padding: '6px 4px',
  borderRadius: '999px',
  border: `1px solid ${active ? FILTER_ACCENT : colors.border}`,
  backgroundColor: active ? FILTER_ACCENT_20 : 'rgba(255,255,255,0.04)',
  color: active ? colors.textPanelDescription : colors.textSecondary,
  fontSize: typography.fontSize.xs,
  fontFamily: typography.fontFamily.primary,
  lineHeight: 1.2,
  textAlign: 'center',
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.6 : 1,
  transition: 'all 0.12s ease',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

/** Chips de rango fijo en grilla de columnas iguales (multi-selección OR). */
function FilterRangeChips({
  options,
  selectedValues = [],
  onChange,
  disabled = false,
  columns = null,
}) {
  const cols = columns || Math.max(options.length, 1);

  const toggle = (value) => {
    const set = new Set(selectedValues);
    if (set.has(value)) set.delete(value);
    else set.add(value);
    const next = Array.from(set);
    onChange(next.length ? next : null);
  };

  return (
    <div style={chipsWrapStyle(cols)}>
      {options.map((opt) => {
        const active = selectedValues.includes(opt.value);
        return (
          <button
            key={opt.key}
            type="button"
            style={chipStyle({ active, disabled })}
            onClick={disabled ? undefined : () => toggle(opt.value)}
            aria-pressed={active}
            title={opt.label}
          >
            {opt.shortLabel || opt.label}
          </button>
        );
      })}
    </div>
  );
}

export default FilterRangeChips;
